import { QuestionComponentProps } from "..";

import { NegativeSectorTagsSelector } from "./components/NegativeSectorTagsSelector";

export function NegativeSectorTags({
  setNextEnabled,
}: QuestionComponentProps): React.ReactElement {
  return (
    <NegativeSectorTagsSelector
      onPreferenceSet={(isPreferenceSet: boolean) =>
        setNextEnabled?.(isPreferenceSet)
      }
    />
  );
}
